<script>
import percentage from '~/filters/percentage';

export default {
  name: 'ReportTableProgressBar',
  functional: true,
  props: {
    tracked: {
      required: true,
    },
    total: {
      required: true,
    },
    success: {
      type: Boolean,
      default: false,
    },
  },
  render(createElement, context) {
    const tracked = context.props.tracked;
    const total = context.props.total;
    const progressBarClass = context.props.success ? 'progress-bar-success' : 'progress-bar-info';
    const width = percentage(tracked, total);

    return createElement('div', Object.assign(context.data, { class: 'progress' }), [
      createElement('div', {
        class: `progress-bar ${progressBarClass}`,
        style: {
          width,
        },
        attrs: {
          role: 'progressbar',
        },
      }),
    ]);
  },
};
</script>
